import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBakerPastryCook = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#855609",
			d: "M29.09 1.085a4.445 4.445 0 0 1 5.82 0L37.127 3a4.45 4.45 0 0 0 3.912.97l2.848-.66a4.46 4.46 0 0 1 5.154 2.722l1.078 2.734a4.48 4.48 0 0 0 3.016 2.689l2.827.747a4.49 4.49 0 0 1 3.306 4.82l-.308 2.925a4.51 4.51 0 0 0 1.429 3.791l2.157 1.984a4.515 4.515 0 0 1 .702 5.814l-1.623 2.446a4.52 4.52 0 0 0-.486 4.025l.994 2.766a4.51 4.51 0 0 1-2.063 5.476l-2.567 1.407a4.5 4.5 0 0 0-2.289 3.336l-.397 2.914c-.3 2.2-2.15 3.85-4.356 3.884l-2.922.045a4.46 4.46 0 0 0-3.568 1.884l-1.697 2.395a4.45 4.45 0 0 1-5.65 1.401l-2.61-1.326a4.44 4.44 0 0 0-4.029 0l-2.608 1.326a4.45 4.45 0 0 1-5.65-1.401l-1.698-2.395a4.46 4.46 0 0 0-3.567-1.884l-2.923-.045a4.476 4.476 0 0 1-4.356-3.884l-.397-2.914a4.5 4.5 0 0 0-2.289-3.337L3.93 46.25a4.51 4.51 0 0 1-2.063-5.476l.994-2.766a4.52 4.52 0 0 0-.486-4.025L.752 31.537a4.515 4.515 0 0 1 .702-5.814L3.61 23.74a4.51 4.51 0 0 0 1.429-3.79l-.308-2.926a4.49 4.49 0 0 1 3.306-4.82l2.827-.747a4.48 4.48 0 0 0 3.016-2.689l1.078-2.734a4.46 4.46 0 0 1 5.154-2.721l2.848.66a4.45 4.45 0 0 0 3.912-.97z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 24,
			fill: "#AE7C2B"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 20,
			fill: "#573704"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E4BC7B",
			fillRule: "evenodd",
			d: "M27 22a3 3 0 0 0-3 3v5.17A3 3 0 0 0 22 33v7a1 1 0 1 0 0 2h20a1 1 0 1 0 0-2v-7a3 3 0 0 0-2-2.83V25a3 3 0 0 0-3-3zm11 3.655V25a1 1 0 0 0-1-1H27a1 1 0 0 0-1 1v.655A3.22 3.22 0 0 1 28 25c1.415 0 2.17.756 2.68 1.267l.027.026c.49.49.733.707 1.293.707s.803-.218 1.293-.707l.026-.026C33.83 25.757 34.585 25 36 25a3.22 3.22 0 0 1 2 .655m-12 2.69V30h12v-1.655a6 6 0 0 1-.68-.612l-.027-.026C36.803 27.217 36.56 27 36 27s-.803.218-1.293.707l-.026.026C34.17 28.243 33.415 29 32 29s-2.17-.756-2.68-1.267l-.027-.026C28.803 27.217 28.56 27 28 27s-.803.218-1.293.707l-.026.026a6 6 0 0 1-.681.612M24 33a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1c-1.415 0-2.17.756-2.68 1.267l-.027.026c-.49.49-.733.707-1.293.707s-.803-.218-1.293-.707l-.026-.026C34.17 34.757 33.415 34 32 34s-2.17.756-2.68 1.267l-.027.026c-.49.49-.733.707-1.293.707s-.803-.218-1.293-.707l-.026-.026C26.17 34.757 25.415 34 24 34zm14.707 3.707c.49-.49.733-.707 1.293-.707v4H24v-4c.56 0 .803.218 1.293.707l.026.026C25.83 37.243 26.585 38 28 38s2.17-.756 2.68-1.267l.027-.026c.49-.49.733-.707 1.293-.707s.803.218 1.293.707l.026.026C33.83 37.243 34.585 38 36 38s2.17-.756 2.68-1.267z",
			clipRule: "evenodd"
		})
	]
});
const ForwardRef = forwardRef(SvgBakerPastryCook);
export default ForwardRef;
